import Vue from 'vue'
import VueRouter from 'vue-router'
import Feed from '../views/Feed.vue'
import Creatives from '../views/Creatives.vue'
import AddPerson from '../views/AddPerson.vue'
import PersonDetails from '../views/PersonDetails.vue'
import ImageDetails from '../views/ImageDetails.vue'
import Favourites from '../views/Favourites.vue'
import SignIn from '../views/SignIn.vue'
import Landingpage from '../views/Landingpage.vue'
import Account from '../views/Account.vue'
import Privacy from '../views/Privacy.vue'
import Legal from '../views/Legal.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'landinpage',
    component: Landingpage
  },
  {
    path: '/signin',
    name: 'signin',
    component: SignIn
  },
  {
    path: '/account',
    name: 'account',
    component: Account
  },
  {
    path: '/discover',
    name: 'feed',
    component: Feed
  },
  {
    path: '/persons',
    name: 'persons',
    component: Creatives
  },
  {
    path: '/person/:id',
    name: 'person',
    component: PersonDetails
  },
  {
    path: '/person/:personId/image/:imageId',
    name: 'image',
    component: ImageDetails
  },
  {
    path: '/image/:imageId',
    name: 'image',
    component: ImageDetails
  },
  {
    path: '/favourites',
    name: 'favourites',
    component: Favourites
  },
  {
    path: '/person/:id/edit',
    name: 'editperson',
    component: AddPerson
  },
  {
    path: '/add',
    name: 'addperson',
    component: AddPerson
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy
  },
  {
    path: '/legal',
    name: 'legal',
    component: Legal
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
